import * as React from "react";

const { Component } = React;

import ImportScadsysUsers from "./Scadsys/ScadsysUserSync";
import ImportScadsysPhotos from "./Scadsys/ScadsysPhotoSync";
import ImportScadsysGroups from "./Scadsys/ScadsysGroupSync";
import ExportUsersToScadsys from "./Scadsys/ScadsysUserUpdate";
import ExportAzurePhotos from "./AzurePhotos";

import ExportEntegyUsers from "./Entegy";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImportADAMStudents from "./ADAM/ImportADAMStudents";
import ImportADAMStaff from "./ADAM/ImportADAMStaff";
import ImportADAMClasses from "./ADAM/ImportADAMClasses";

import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";
import * as AccountStore from "../account/AccountStore";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import ImportEdAdminUsers from "./EdAdmin";
export class Integration {
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;

    constructor(name = "") {
        this.name = name;
    }
}

interface Tabs {
    scadsysImport: boolean;
    scadsysPhotoImport: boolean;
    scadsysGroupImport: boolean;
    scadsysUpdate: boolean;
    excel: boolean;
    entegy: boolean;
    adamStudents: boolean;
    adamStaff: boolean;
    adamClasses: boolean;
    azurePhoto: boolean;
    edadmin: boolean;
}

interface IntegrationsState {
    tabs: Tabs;
    policies: any;
    currentUser: any;
}

interface IntegrationsProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class Integrations extends Component<IntegrationsProps, IntegrationsState> {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                scadsysImport: true,
                scadsysPhotoImport: false,
                scadsysGroupImport: false,
                scadsysUpdate: false,
                excel: false,
                entegy: false,
                adamStudents: false,
                adamStaff: false,
                adamClasses: false,
                azurePhoto: false,
                edadmin: false,
            },
            policies: undefined,
            currentUser: undefined,
        };
    }

    hasPermission(permission) {
        if (this.state.currentUser && this.state.policies) {
            if (this.state.currentUser.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return this.state.policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            AccountStore.GetCurrentLoggedInUser().then((user) => {
                this.setState({ currentUser: user });
            });
            PermissionStore.GetMyPermissions().then((response) => {
                this.setState({ policies: response.data });
            });
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    showTab = (tab) => {
        this.setState((prevState) => {
            Object.keys(prevState.tabs).forEach(function (key) {
                prevState.tabs[key] = key == tab;
            });
            return { tabs: prevState.tabs };
        });
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-xs-6 col-md-3 pr-0">
                        <div className="list-group list-group-flush border">
                            {this.hasPermission("importUsersFromScadsys") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.scadsysImport ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("scadsysImport")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Users from Scadsys
                                </a>
                            )}
                            {this.hasPermission("importUsersFromScadsys") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.scadsysPhotoImport ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("scadsysPhotoImport")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "image"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Photos from Scadsys
                                </a>
                            )}
                            {this.hasPermission("importGroupsFromScadsys") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.scadsysGroupImport ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("scadsysGroupImport")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "users"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Groups from Scadsys
                                </a>
                            )}
                            {this.hasPermission("exportUsersToScadsys") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.scadsysUpdate ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("scadsysUpdate")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Export to Scadsys
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.adamStudents ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("adamStudents")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Students from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.adamStaff ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("adamStaff")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Staff from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.adamClasses ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("adamClasses")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "users"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import Classes from ADAM
                                </a>
                            )}
                            {this.hasPermission("importUsersFromADAM") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.edadmin ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("edadmin")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "user-graduate"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Import from EdAdmin
                                </a>
                            )}
                            {this.hasPermission("exportUsersToEntegy") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.entegy ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("entegy")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "mobile"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Export to Entegy
                                </a>
                            )}
                            {this.hasPermission("exportPhotosToAzure") && (
                                <a href="#" className={`list-group-item list-group-item-action ${this.state.tabs.azurePhoto ? "list-group-item-primary" : ""}`} onClick={() => this.showTab("azurePhoto")}>
                                    <span>
                                        <FontAwesomeIcon className="me-1" icon={["fad", "image"]}></FontAwesomeIcon>
                                    </span>{" "}
                                    Export Photo to Azure
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="col px-5 px-md-1 pr-md-4">
                        {this.hasPermission("importUsersFromScadsys") && this.state.tabs.scadsysImport && <ImportScadsysUsers organization={this.props.organization} />}
                        {this.hasPermission("importUsersFromScadsys") && this.state.tabs.scadsysPhotoImport && <ImportScadsysPhotos organization={this.props.organization} />}
                        {this.hasPermission("importGroupsFromScadsys") && this.state.tabs.scadsysGroupImport && <ImportScadsysGroups organization={this.props.organization} />}
                        {this.hasPermission("exportUsersToScadsys") && this.state.tabs.scadsysUpdate && <ExportUsersToScadsys organization={this.props.organization} />}
                        {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamStudents && <ImportADAMStudents organization={this.props.organization} />}

                        {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamStaff && <ImportADAMStaff organization={this.props.organization} />}
                        {this.hasPermission("importUsersFromADAM") && this.state.tabs.adamClasses && <ImportADAMClasses organization={this.props.organization} />}

                        {this.hasPermission("importUsersFromADAM") && this.state.tabs.edadmin && <ImportEdAdminUsers organization={this.props.organization} />}
                        {this.hasPermission("exportUsersToEntegy") && this.state.tabs.entegy && <ExportEntegyUsers organization={this.props.organization} />}
                        {this.hasPermission("exportPhotosToAzure") && this.state.tabs.azurePhoto && <ExportAzurePhotos organization={this.props.organization} />}
                    </div>
                </div>
            </div>
        );
    }
}
